/**
 * package: com.inq.ui
 * class: ArrayCollection
 * root Object
 * @constructor
 */
com.inq.ui.ArrayCollection = function() {
	this._collection = new Array();
};
$hxClasses.registerClass(com.inq.ui.ArrayCollection, "com.inq.ui.ArrayCollection");

/**
 * getItemAt
 *
 * $type TFun([{ name => indx, t => TInst(Int,[]), opt => false }],TDynamic(null))
 * public function getItemAt(indx:Int):Dynamic
 * @public
 * @this com.inq.ui.ArrayCollection
 * @param {number}  indx 
 * @return {null}
 */
com.inq.ui.ArrayCollection.prototype.getItemAt = function(indx) {
	if(indx < this._collection.length) return this._collection[indx];
	return null;
};


/**
 * getLength
 *
 * $type TFun([],TInst(Int,[]))
 * private function getLength():Int
 * @private
 * @this com.inq.ui.ArrayCollection
 * @return {number}
 */
com.inq.ui.ArrayCollection.prototype.getLength = function() {
	return this._collection.length;
};


/**
 * addItem
 *
 * $type TFun([{ name => itm, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function addItem(itm:Dynamic)
 * @public
 * @this com.inq.ui.ArrayCollection
 * @param {null}  itm 
 * @return {void}
 */
com.inq.ui.ArrayCollection.prototype.addItem = function(itm) {
	this._collection[this._collection.length] = itm;
};

/** @type {number} */
com.inq.ui.ArrayCollection.prototype.length = null;
/** @private @type {Array} */
com.inq.ui.ArrayCollection.prototype._collection = null;
/** @type {com.inq.ui.ArrayCollection} */
com.inq.ui.ArrayCollection.prototype.__class__ = com.inq.ui.ArrayCollection;
